export default {
  errorDefault: 'Произошла ошибка',
  unknown: 'Неизвестно',
};
